import { render, staticRenderFns } from "./ServiceExtraFields.vue?vue&type=template&id=2518cdd3&scoped=true&"
import script from "./ServiceExtraFields.vue?vue&type=script&lang=js&"
export * from "./ServiceExtraFields.vue?vue&type=script&lang=js&"
import style0 from "./ServiceExtraFields.vue?vue&type=style&index=0&id=2518cdd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2518cdd3",
  null
  
)

export default component.exports